import { Translation } from "@shared/types/translation";
import { useLocale } from "@translations/locale-context";
import Image from "next/legacy/image";

const TOOLS: Translation[] = [
    {
        cs: "Google analytics",
        en: "Google analytics",
    },
    {
        cs: "Sledování pohybů myši nebo dotyky prstů",
        en: "Tracking mouse movements or finger touches",
    },
    {
        cs: "Teplotní mapy",
        en: "Heat maps",
    },
    {
        cs: "Double diamond framework",
        en: "Double diamond framework",
    },
    {
        cs: "Databáze přes 100 000\u00a0h uživatelských výzkumů",
        en: "Database of over 100,000\u00a0hours of user research",
    },
    {
        cs: "UX checklist",
        en: "UX checklist",
    },
    {
        cs: "Výsledky již několikrát otestovaných A/B testů",
        en: "Results of proven A/B tests",
    },
    {
        cs: "Konverzní trychtýře",
        en: "Conversion funnels",
    },
    {
        cs: "Uživatelské rozhovory",
        en: "User interviews",
    },
    {
        cs: "Testy prvního dojmu",
        en: "First impression tests",
    },
    {
        cs: "Dotazníkové šetření",
        en: "Surveys",
    },
    {
        cs: "Hloubkové rozhovory",
        en: "In-depth interviews",
    },
];

const ContentCs = () => (
    <>
        <h2 className="pb-4 text-h2Mobile font-bold text-uxfViolet sm:text-medium xl:text-h5">
            Pracujeme s&nbsp;nástroji a&nbsp;metodami, které <span className="text-uxfOrange">nás nezklamaly</span>
        </h2>
        <p className="text-small1 text-uxfMuted75 sm:text-body">
            Nedílnou součástí UX auditu jsou potřebné nástroje a&nbsp;metody
        </p>
    </>
);

const ContentEn = () => (
    <>
        <h2 className="pb-4 text-h2Mobile font-bold text-uxfViolet sm:text-medium xl:text-h5">
            We work with tools and methods that
            <span className="text-uxfOrange"> have not let us down</span>
        </h2>
        <p className="text-small1 text-uxfMuted75 sm:text-body">
            The necessary tools and methods are an&nbsp;integral part of a&nbsp;UX audit
        </p>
    </>
);

export const ToolsSection = () => {
    const locale: "cs" | "en" = useLocale();
    return (
        <div className="container p-5 md:px-0">
            <div className="pb-10">{locale === "en" ? <ContentEn /> : <ContentCs />}</div>
            <div className="lg:flex">
                <div className="pb-14">
                    <div className="pl-6 text-small1 text-uxfMuted75 sm:text-body">
                        <div className="">
                            <ul className="list-disc space-y-2 md:columns-2 md:gap-6">
                                {TOOLS.map(({ cs, en }, index) => (
                                    <li key={index}>{[locale === "en" ? en : cs]}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="mx-5 text-center">
                    <Image
                        src="/static/landing-pages/tools.png"
                        alt={locale === "en" ? "Exemplary UX audit tools" : "Vzorové nástroje a metody UX auditu"}
                        width={372}
                        height={363}
                    />
                </div>
            </div>
        </div>
    );
};
